import { Component, Inject, OnInit } from '@angular/core';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { DatePipe, Location } from '@angular/common';
import { log } from 'console';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
@Component({
  selector: 'app-teacher-availibilty',
  templateUrl: './teacher-availibilty.component.html',
  styleUrls: ['./teacher-availibilty.component.scss']
})
export class TeacherAvailibiltyComponent implements OnInit {
  teacherAssignForm: FormGroup;
  internalTeachersArray: FormArray;
  externalTeachersArray: FormArray;
  allTeachersArray: FormArray;
  collegeList: any;
  filteredCollegeList: any;
  dialogRef: MatDialogRef<any>;
  subjectList: any;
  filteredsubjectList: any;
  CourseList: any;
  filteredListCourse: any;
  teachersList: any;
  filteredteachersList: any;
  savedTeachers: any;
  InterTeach: boolean = false;
  ExterTeach: boolean = false;
  ExterTeachCnt: any;
  InterTeachCnt: any;
  internalError: string;
  externalError: string;
  internalSelected: any;
  externalSelected: any;
  selectedCount: any;
  sessionList: any[];
  SessionFilterList: any[];
  ExamId: any;
  savedTeachersData: any;
  APIService: string;
  selectAllChecked: boolean = false;
  requestTypeList
  filteredrequestTypeList
  showProviReport: boolean;
  showFieldsForAdd: boolean;
  AvailabilityMesg: string;
  msgShow: boolean;
  showAlert: any = {
    show: false,
    message: ''
  };
  constructor(public fb: FormBuilder,
    public umsService: UmsService, @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService, private datePipe: DatePipe,
    private modalPopupService: ModalpopService,
    private httpClient: HttpClient,) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.teacherAssignForm = this.fb.group({
      CgCode: new FormControl('', Validators.required),
      CoCode: new FormControl('', Validators.required),
      SubCode: new FormControl('', Validators.required),
      SessionId: new FormControl('', Validators.required),
      CollegeDistrict: new FormControl(''),
      count: new FormControl(''),
      FromDate: new FormControl('', Validators.required),
      ToDate: new FormControl('', Validators.required),
      ReplyBefore: new FormControl('', Validators.required),
      ReqType: new FormControl('', Validators.required),
      internalTeachersArray: this.fb.array([]),
      externalTeachersArray: this.fb.array([]),
      allTeachersArray: this.fb.array([]),
    });
    this.getCollege();
    this.getCourse();
    this.fetchSession();
    this.fetchRequestType();

    if (this.data.key == "New") {
      this.showProviReport = false;
      this.showFieldsForAdd = true
    } else if (this.data.key == "31(a)") {
      this.showProviReport = true;
      this.showFieldsForAdd = false;
    }

  }


  getCollege() {
    let payload = {}
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  getsubjects(CoCode) {
    this.spinner.show();
    // this.table = true;
    // this.SubCode = ''
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.getCoursewiseSub(payload).subscribe(res => {
      this.spinner.hide()
      this.subjectList = res.data;
      this.filteredsubjectList = this.subjectList.slice();
    });
  }


  getCourse() {
    this.spinner.show();
    const payload = {};
    // this.table = false;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getCount(item) {
    this.ExterTeachCnt = item.ExternalCount;
    this.InterTeachCnt = item.InternalCount;
    this.ExamId = item.EmId
    this.getTeachersData(item);

    this.getTimetableDate();
  }
  getTeachersData(item) {
    this.getExaminerRequest()
    this.teacherAssignForm.controls['CollegeDistrict'].setValue(item.DsName)
    const payload = {};
    payload['CgCode'] = this.teacherAssignForm.value.CgCode;
    payload['SubCode'] = this.teacherAssignForm.value.SubCode;
    payload['ReqType'] = this.teacherAssignForm.value.ReqType;
    this.umsService.getSubWiseTeachers(payload).subscribe(res => {
      // this.msgShow = false;
      this.spinner.hide()

       if (res.data && res.data.length > 0) {
    const cgCode = res.data[0].CgCode;
    if (cgCode) {
      this.teacherAssignForm.patchValue({
        CgCode: cgCode
      });
    }
  }

      this.teachersList = res.data;
      this.filteredteachersList = this.teachersList.slice();
      const internalTeachersArray = this.teacherAssignForm.get('internalTeachersArray') as FormArray;
      const externalTeachersArray = this.teacherAssignForm.get('externalTeachersArray') as FormArray;

      const allTeachersArray = this.teacherAssignForm.get('allTeachersArray') as FormArray;
      allTeachersArray.clear();

      internalTeachersArray.clear();
      externalTeachersArray.clear();
      this.savedTeachersData;
      this.teachersList.forEach(teacher => {
        const saved = this.savedTeachersData.find(t => {
          return t.TechId === teacher.TeacherId || t.TechId === teacher.TeacherId;
        });
        // let UGExperience = teacher.UGExpYears + 'Y,' + teacher.UGExpMonths + 'M,' + teacher.UGExpDays + 'D'
        // let PGExperience = teacher.PGExpYears + 'Y,' + teacher.PGExpMonths + 'M,' + teacher.PGExpDays + 'D'
        if (saved) {
          this.teacherAssignForm.controls['FromDate'].setValue(this.savedTeachersData[0].FromDate)
          this.teacherAssignForm.controls['ToDate'].setValue(this.savedTeachersData[0].ToDate)
          this.teacherAssignForm.controls['ReplyBefore'].setValue(this.savedTeachersData[0].ReplyBefore)

          const teacherFormGroup = this.fb.group({
            // FromDate: new FormControl(this.savedTeachersData[0].FromDate),
            // ToDate: new FormControl(teacher.ToDate),
            TeacherId: new FormControl(teacher.TeacherId),
            TeacherName: new FormControl(teacher.TeacherName),
            CollegeName: new FormControl(teacher.CollegeName),
            DsName: new FormControl(teacher.DsName),
            Designation: new FormControl(teacher.Designation),
            Type: new FormControl(teacher.Type),
            Availability: new FormControl(teacher.Availability),
            teachercheckbox: new FormControl(!!saved),
            // UGExperience: new FormControl(UGExperience),
            // PGExperience: new FormControl(PGExperience),
            HOD: new FormControl(teacher.isHOD),
          });

          this.InterTeach = true
          allTeachersArray.push(teacherFormGroup);
        } else {
          // this.teacherAssignForm.controls['FromDate'].setValue('')
          // this.teacherAssignForm.controls['ToDate'].setValue('')
          // this.teacherAssignForm.controls['ReplyBefore'].setValue('')

          // If no match is found in savedTeachersData, still add the teacher with a default checkbox value (unchecked)
          const teacherFormGroup = this.fb.group({
            TeacherId: new FormControl(teacher.TeacherId),
            TeacherName: new FormControl(teacher.TeacherName),
            CollegeName: new FormControl(teacher.CollegeName),
            DsName: new FormControl(teacher.DsName),
            Designation: new FormControl(teacher.Designation),
            Type: new FormControl(teacher.Type),
            // UGExperience: new FormControl(UGExperience),
            // PGExperience: new FormControl(PGExperience),
            HOD: new FormControl(teacher.isHOD),
            Availability: new FormControl(teacher.Availability),
            teachercheckbox: new FormControl(false)
          });
          this.InterTeach = true
          allTeachersArray.push(teacherFormGroup);
        }
      });


    });
  }

  getControlsInt() {
    return (this.teacherAssignForm.get('internalTeachersArray') as FormArray).controls;
  }
  getControlsAllTachers() {
    return (this.teacherAssignForm.get('allTeachersArray') as FormArray).controls;
  }

  selectSingleTeacher(index: number, checked: boolean): void {
  const allTeachersArray = this.teacherAssignForm.get('allTeachersArray') as FormArray;

  const teacherControl = allTeachersArray.at(index);

  if (teacherControl) {
    teacherControl.get('teachercheckbox')?.setValue(checked);
  }

  this.selectAllChecked = allTeachersArray.controls.length > 0 &&
    allTeachersArray.controls.every(
      control => control.get('teachercheckbox')?.value === true
    );
}
  getControlsExt() {
    return (this.teacherAssignForm.get('externalTeachersArray') as FormArray).controls;
  }

  save() {
  if (this.teacherAssignForm.invalid) {
    this.teacherAssignForm.get('CoCode').markAsTouched();
    this.teacherAssignForm.get('SubCode').markAsTouched();
    this.teacherAssignForm.get('SessionId').markAsTouched();
    this.teacherAssignForm.get('FromDate').markAsTouched();
    this.teacherAssignForm.get('ToDate').markAsTouched();
    this.teacherAssignForm.get('ReplyBefore').markAsTouched();
    this.teacherAssignForm.get('ReqType').markAsTouched();

  } else if (
    !(this.teacherAssignForm.get('allTeachersArray') as FormArray)
      .controls
      .some(control => control.get('teachercheckbox')?.value === true)
  ) {

    let data = {};
    data['message'] = 'Please select at least one teacher before submitting.';
    data['title'] = 'Alert';
    data['icon'] = 'fas fa-close';

    this.dialogRef =
      this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );

  } else {

    if (this.showAlert.show) {

      let data = {};
      data['message'] = this.showAlert.message;
      data['title'] = 'Warning';
      data['icon'] = 'fa fa-question';

      this.dialogRef =
        this.modalPopupService.openPopup<ConformationModelComponent>(
          ConformationModelComponent,
          data
        );

      this.dialogRef.afterClosed().subscribe((result) => {

        if (result === 'yes') {
          this.deletedata();
        } else {

          let gstrVldtMesg = 'Processing Cancelled';

          let data = {};
          data['message'] = gstrVldtMesg;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';

          this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
        }

      });

    } else {
      this.deletedata();
    }

  }
}

  // save() {
  //   if (this.teacherAssignForm.invalid) {
  //     // this.teacherAssignForm.get('CgCode').markAsTouched();
  //     this.teacherAssignForm.get('CoCode').markAsTouched();
  //     this.teacherAssignForm.get('SubCode').markAsTouched();
  //     this.teacherAssignForm.get('SessionId').markAsTouched();
  //     this.teacherAssignForm.get('FromDate').markAsTouched();
  //     this.teacherAssignForm.get('ToDate').markAsTouched();
  //     this.teacherAssignForm.get('ReplyBefore').markAsTouched();
  //     this.teacherAssignForm.get('ReqType').markAsTouched();
  //   }
  //   else if (!this.selectAllChecked) {
  //     let data = {}
  //     data['message'] = 'Please Check the Select All checkbox before Submitting.'
  //     data['title'] = 'Alert'
  //     data['icon'] = 'fas fa-close'
  //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

  //   } else {
  //     if (this.showAlert.show) {
  //       let data = {};
  //       data['message'] = this.showAlert.message;
  //       data['title'] = 'Warning';
  //       data['icon'] = 'fa fa-question';
  //       this.dialogRef =
  //         this.modalPopupService.openPopup<ConformationModelComponent>(
  //           ConformationModelComponent,
  //           data
  //         );
  //       this.dialogRef.afterClosed().subscribe((result) => {
  //         if (result === 'yes') {
  //           this.deletedata();
  //           return true;
  //         } else {
  //           let gstrVldtMesg = 'Processing Cancelled';
  //           let data = {};
  //           data['message'] = gstrVldtMesg;
  //           data['title'] = 'Information';
  //           data['icon'] = 'fas fa-close';
  //           this.dialogRef =
  //             this.modalPopupService.openPopup<AlertBoxComponent>(
  //               AlertBoxComponent,
  //               data
  //             );
  //           return false;
  //         }
  //       });

  //     }
  //     else {
  //       this.deletedata();
  //     }


  //   }

  // }


  onCheckboxChangeInt(index: number) {
    const controls = this.teacherAssignForm.get('internalTeachersArray')['controls'];
    const isChecked = controls[index].get('teachercheckbox').value;

    // Update the selected count based on current selections
    this.selectedCount = controls.filter(c => c.get('teachercheckbox').value).length;
  }

  onCheckboxChangeExt(index: number) {
    const controls = this.teacherAssignForm.get('externalTeachersArray')['controls'];
    const selectedCount = controls.filter(c => c.get('teachercheckbox').value).length;

    const isChecked = controls[index].get('teachercheckbox').value;

    // If the checkbox is checked and we haven't reached the max count yet
    // if (!isChecked && selectedCount < this.ExterTeachCnt) {
    //   controls[index].get('teachercheckbox').patchValue(true, { emitEvent: false });
    // } 
    // // If it's unchecked, we allow it as long as the count doesn't drop below the required minimum
    // else if (isChecked && selectedCount > this.ExterTeachCnt) {
    //   controls[index].get('teachercheckbox').patchValue(false, { emitEvent: false });
    // }
  }

  validateSelection(): boolean {
    let isValid = true;
    this.internalError = '';
    this.externalError = '';

    // Get the selected count for both internal and external
    this.internalSelected = this.teacherAssignForm.get('internalTeachersArray')['controls']
      .filter(c => c.get('teachercheckbox').value).length;

    this.externalSelected = this.teacherAssignForm.get('externalTeachersArray')['controls']
      .filter(c => c.get('teachercheckbox').value).length;

    // Check if the number of selected internal teachers matches the required count
    if (this.internalSelected != this.InterTeachCnt) {
      this.internalError = `Please select exactly ${this.InterTeachCnt} Chairperman/Convener.`;
      isValid = false;
    }

    // Check if the number of selected external teachers matches the required count
    if (this.externalSelected != this.ExterTeachCnt) {
      this.externalError = `Please select exactly ${this.ExterTeachCnt} External Examiner(s).`;
      isValid = false;
    }

    return isValid;
  }

  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide();
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  getExaminerRequest() {
    let payload = {};
    // payload['CgCode'] = this.teacherAssignForm.value.CgCode;
    payload['SubCode'] = this.teacherAssignForm.value.SubCode;
    payload['CoCode'] = this.teacherAssignForm.value.CoCode;
    payload['SessionId'] = this.teacherAssignForm.value.SessionId;
    this.umsService.getTeacherAvailablity(payload).subscribe(res => {
      this.savedTeachersData = res.data;
      this.spinner.hide();
      if (res.status) {
        this.AvailabilityMesg = ""
        // this.showProviReport = true
        this.msgShow = false;
        this.spinner.hide();
      } else {
        this.showProviReport = false;
        this.msgShow = true;
        this.AvailabilityMesg = "The availability request has not been sent yet."
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.showProviReport = false
      this.spinner.hide();

    });
  }


  deletedata() {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {

        SessionId: this.teacherAssignForm.value.SessionId,
        SubId: this.teacherAssignForm.value.SubCode,
        CoCode: this.teacherAssignForm.value.CoCode,
        // CgCode: this.teacherAssignForm.value.CgCode,
        EmId: this.ExamId,
      },
    };
    this.httpClient.delete(this.APIService + '/supervisor/InternalExternalTeacherAvailablity', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        this.submitExaminer();
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.ngOnInit();
      });

  }


  submitExaminer() {
    this.spinner.show();
    let payload = this.teacherAssignForm.value;
    const rawFromDate = this.teacherAssignForm.get('FromDate')?.value;
    const rawToDate = this.teacherAssignForm.get('ToDate')?.value;
    const rawReplyBefore = this.teacherAssignForm.get('ReplyBefore')?.value;

    const formattedFromDate = this.datePipe.transform(rawFromDate, 'yyyy-MM-dd');;
    const formattedToDate = this.datePipe.transform(rawToDate, 'yyyy-MM-dd');;
    const formattedReplyBefore = this.datePipe.transform(rawReplyBefore, 'yyyy-MM-dd');;
    // let internalTeachersArray = this.teacherAssignForm.get('internalTeachersArray') as FormArray;
    // let externalTeachersArray = this.teacherAssignForm.get('externalTeachersArray') as FormArray;

    let allTeachersArray = this.teacherAssignForm.get('allTeachersArray') as FormArray;
    const combinedArray = [...allTeachersArray.value];
    let teacherArray = combinedArray.filter(item => item.teachercheckbox === true);
    const finalPayload = teacherArray.map(item => {
      return {
        SessionId: payload.SessionId,
        SubId: payload.SubCode,
        CoCode: payload.CoCode,
        CgCode: payload.CgCode,
        FromDate: formattedFromDate,
        ToDate: formattedToDate,
        ReplyBefore: formattedReplyBefore,
        EmId: this.ExamId,
        Notes: payload.Notes,
        ReqType: payload.ReqType,
        // ExternalTechId: item.Type === 'External' ? item.TeacherId : '',
        InternalTechId: item.TeacherId,
        IsPractical: item.teachercheckbox
      };
    });

    const saveRequests = finalPayload.map(teacherPayload =>
      this.umsService.saveAvailablityTeacher(teacherPayload)
    );

    // Wait for all saveExaminer requests to complete
    forkJoin(saveRequests).subscribe({
      next: (responses) => {
        // Check if all responses are successful
        const allSuccessful = responses.every(res => res.status);
        this.spinner.hide();
        const data: any = {

          title: 'Information',
          icon: 'fas fa-check',
          message: allSuccessful ? 'Availability Request Sent Successfully' : 'Some entries failed to save.'
        };

        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        const data: any = {
          title: 'Information',
          icon: 'fas fa-box-open',
          message: error.error.message || 'An error occurred.'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  toggleSelectAll(event: any) {
    const input = event.target as HTMLInputElement;
    this.selectAllChecked = input.checked;
    const checked = (event.target as HTMLInputElement).checked;
    const allTeachersArray = this.teacherAssignForm.get('allTeachersArray') as FormArray;
    allTeachersArray.controls.forEach(control => {
      control.patchValue({ teachercheckbox: checked });
    });
  }

  fetchRequestType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'ReqTy';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.requestTypeList = res.data;
        this.filteredrequestTypeList = this.requestTypeList.slice();
      } else {
        this.requestTypeList = [];
        this.filteredrequestTypeList = this.requestTypeList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();

      })
  }


  // GenerateProviList() {
  //   const batchCount = 3;
  //   const payload = {
  //     SubId: this.teacherAssignForm.value.SubCode
  //   };
  //   this.spinner.show();
  //   for (let i = 0; i < batchCount; i++) {
  //     this.umsService.generateRandomAssiTea(payload).subscribe(
  //       (res) => {
  //         if (res.status) {
  //           const data = {
  //             message: "The provisional list of examiners has been generated",
  //             title: 'Information',
  //             icon: 'fas fa-check'
  //           };
  //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //         }
  //         if (i === batchCount - 1) {
  //           this.spinner.hide();
  //         }
  //       },
  //       (error: HttpErrorResponse) => {
  //         if (i === batchCount - 1) {
  //           this.spinner.hide();
  //         }
  //       }
  //     );
  //   }

  // }

  GenerateProviList() {

  if (
    !this.teacherAssignForm.value.CoCode ||
    !this.teacherAssignForm.value.SubCode ||
    !this.teacherAssignForm.value.SessionId ||
    !this.teacherAssignForm.value.ReqType
  ) {
    let data = {
      message: 'Please select all required fields before generating provisional list.',
      title: 'Alert',
      icon: 'fas fa-exclamation-triangle'
    };

    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    return; 
  }

  this.spinner.show();

  const payload = {
    SubId: this.teacherAssignForm.value.SubCode,
    SessionId: this.teacherAssignForm.value.SessionId,
  };

  this.umsService.generateRandomAssiTea(payload).subscribe((res) => {
    this.spinner.hide();

    if (res.status) {
      let data = {
        message: "The provisional list of examiners has been generated",
        title: 'Information',
        icon: 'fas fa-check'
      };

      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
  },
  (ERROR: HttpErrorResponse) => {
    this.spinner.hide();
  });
}
  getTimetableDate() {
    this.spinner.show();
    const payload = {};
    payload['SubId'] = this.teacherAssignForm.value.SubCode;
    payload['SessionId'] = this.teacherAssignForm.value.SessionId;
    this.umsService.getPracticalDate(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        const FromDate = res.data[0].PracticalExamFrom;
        const ToDate = res.data[0].PracticalExamTo;
        this.showAlert.show = res.data[0].ShowMessage;
        this.showAlert.message = res.data[0].Message;

        const formattedFromDate = this.datePipe.transform(FromDate, 'yyyy-MM-dd');
        const formattedToDate = this.datePipe.transform(ToDate, 'yyyy-MM-dd');


        this.teacherAssignForm.controls['FromDate'].setValue(formattedFromDate)
        this.teacherAssignForm.controls['ToDate'].setValue(formattedToDate)


      } else {

      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();

      })
  }

  // New method for Reciprocal Provisional List
  GenerateReciprocalProviList() {
    // Validate required fields
    if (
      !this.teacherAssignForm.value.CoCode ||
      !this.teacherAssignForm.value.SubCode ||
      !this.teacherAssignForm.value.SessionId ||
      !this.teacherAssignForm.value.ReqType
    ) {
      let data = {
        message: 'Please select all required fields before generating reciprocal provisional list.',
        title: 'Alert',
        icon: 'fas fa-exclamation-triangle'
      };

      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    this.spinner.show();

    const payload = {
      MainSubjectId: this.teacherAssignForm.value.SubCode,
      SessionId: this.teacherAssignForm.value.SessionId
    };

    // Call the reciprocal API endpoint
    this.umsService.generateReciprocalProviList(payload).subscribe({
      next: (res) => {
        this.spinner.hide();

        if (res.status) {
          let data = {
            message: res.message || "The reciprocal provisional list of examiners has been generated",
            title: 'Information',
            icon: 'fas fa-check'
          };

          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          
          // Refresh the data after successful generation
          this.getCount(this.teacherAssignForm.value);
        } else {
          let data = {
            message: res.message || 'Failed to generate reciprocal provisional list',
            title: 'Alert',
            icon: 'fas fa-close'
          };

          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {
          message: ERROR.error?.message || 'An error occurred while generating reciprocal provisional list',
          title: 'Alert',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }
}